// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgramItemContainer_diet_container__2akOe"};